import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule, LOCALE_ID } from "@angular/core";
import { HttpModule, Http, RequestOptions } from "@angular/http";
import { FormsModule } from "@angular/forms";
import { NgxGalleryModule } from "ngx-gallery";
import { ToastModule } from "ng2-toastr/ng2-toastr";
import { ToastOptions } from "ng2-toastr";
import { CustomOption } from "./config/custom-toast-options";
import { LaddaModule } from "angular2-ladda";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { SlickModule } from "ngx-slick";
import { AuthHttp, AuthConfig } from "angular2-jwt";
import { DragulaModule } from "ng2-dragula";
import { FileUploadModule } from "ng2-file-upload";
import { QuillModule } from "ngx-quill";

// Rutas
import { APP_ROUTING } from "./app.routes";

// Componentes
import { AppComponent } from "./app.component";
import { BasePublicComponent } from "./pages/shared/base-public/base-public.component";
import { NavbarComponent } from "./components/structure/navbar/navbar.component";
import { NavlinksComponent } from "./components/structure/navlinks/navlinks.component";
import { FooterComponent } from "./components/structure/footer/footer.component";
import { MediaViewerComponent } from "./components/utils/media-viewer/media-viewer.component";
import { BreadcrumbComponent } from "./components/utils/breadcrumb/breadcrumb.component";
import { GalleryComponent } from "./components/utils/gallery/gallery.component";
import { EditBannerComponent } from "./pages/admin/edit-banner/edit-banner.component";
import { ConfirmComponent } from "./components/utils/confirm/confirm.component";
import { SfGalleryComponent } from "./components/utils/sf-gallery/sf-gallery.component";

// Paginas
import { HomeComponent } from "./pages/shared/home/home.component";
import { CategoriaComponent } from "./pages/shared/categoria/categoria.component";
import { ProductoComponent } from "./pages/shared/producto/producto.component";
import { CotizacionComponent } from "./pages/shared/cotizacion/cotizacion.component";
import { FichaTecnicaComponent } from "./pages/shared/ficha-tecnica/ficha-tecnica.component";
import { ResultadoBusquedaComponent } from "./pages/shared/resultado-busqueda/resultado-busqueda.component";
import { EspecialesSfComponent } from "./pages/shared/especiales-sf/especiales-sf.component";
import { CategoriaEspecialComponent } from "./pages/shared/categoria-especial/categoria-especial.component";
import { EspecialesPortadaComponent } from "./pages/admin/especiales-portada/especiales-portada.component";
import { SeleccionSfComponent } from "./pages/admin/seleccion-sf/seleccion-sf.component";
import { BannerEncuentralosComponent } from "./pages/admin/banner-encuentralos/banner-encuentralos.component";
import { MarcasComponent } from "./pages/admin/marcas/marcas.component";
import { BandInformacionComponent } from "./pages/admin/banda-informacion/banda-informacion.component";
import { PopupComponent } from "./pages/admin/popup/popup.component";
import { AdjuntoComponent } from "./pages/admin/adjunto/adjunto.component";
import { CategoriasComponent } from "./pages/admin/categorias/categorias.component";
import { EditCategoriasComponent } from "./pages/admin/edit-categorias/edit-categorias.component";
import { CrearCodigoComponent } from "./pages/admin/crear-codigo/crear-codigo.component";
import { OrdenarProductosComponent } from "./pages/admin/ordenar-productos/ordenar-productos.component";
import { HistorialCambiosProductosComponent } from "./pages/admin/historial-cambios-productos/historial-cambios-productos.component";
import { DescargarProductosComponent } from "./pages/admin/descargar-productos/descargar-productos.component";
import { PreviewProductoComponent } from "./pages/shared/preview-producto/preview-producto.component";
import { EditPopupComponent } from "./pages/admin/edit-popup/edit-popup.component";
import { EditAdjuntoComponent } from "./pages/admin/edit-adjunto/edit-adjunto.component";

import { BaseAdminComponent } from "./pages/admin/base-admin/base-admin.component";
import { LoginComponent } from "./pages/admin/login/login.component";
import { AdminNavbarComponent } from "./components/structure/admin-navbar/admin-navbar.component";
import { AdminSiteComponent } from "./pages/admin/admin-site/admin-site.component";
import { AdminSiteMenuComponent } from "./components/structure/admin-site-menu/admin-site-menu.component";
import { DestacadosHomeComponent } from "./pages/admin/destacados-home/destacados-home.component";
import { CategoriasEspecialesComponent } from "./pages/admin/categorias-especiales/categorias-especiales.component";
import { CrearCategoriaEspecialComponent } from "./pages/admin/crear-categoria-especial/crear-categoria-especial.component";
import { EditBannerCategoriaComponent } from "./pages/admin/edit-banner-categoria/edit-banner-categoria.component";
import { PreviewCategoriaEspecialComponent } from "./pages/shared/preview-categoria-especial/preview-categoria-especial.component";
import { ListaProductosComponent } from "./pages/admin/lista-productos/lista-productos.component";
import { CrearProductoComponent } from "./pages/admin/crear-producto/crear-producto.component";
import { ColorSelectorComponent } from "./components/color-selector/color-selector.component";
import { CargarCodigosComponent } from "./pages/admin/cargar-codigos/cargar-codigos.component";
import { DescargarListadoCodigosComponent } from "./pages/admin/descargar-listado-codigos/descargar-listado-codigos.component";
import { ClickOutsideModule } from "ng4-click-outside";

// Servicios
import { TokenCommonService } from "./services/token-common.service";

import { GeneralService } from "./services/general/general.service";
import { BannerService } from "./services/banner/banner.service";
import { MarcaService } from "./services/marca/marca.service";
import { PopupService } from "./services/popup/popup.service";
import { BandaInformacionService } from "./services/banda-informacion/banda-informacion.service";
import { AdjuntoService } from "./services/adjunto/adjunto.service";
import { CategoriaService } from "./services/categoria/categoria.service";
import { ProductoService } from "./services/producto/producto.service";
import { CarritoService } from "./services/carrito/carrito.service";
import { UsuarioService } from "./services/usuario/usuario.service";
import { CotizacionService } from "./services/cotizacion/cotizacion.service";
import { LoginService } from "./services/login/login.service";
import { AuthService } from "./services/auth/auth.service";
import { ConfirmService } from "./services/confirm/confirm.service";
import { ArchivoService } from "./services/archivo/archivo.service";
import { PreviewFantasyCategoryService } from "./services/preview-fantasy-category/preview-fantasy-category.service";
import { PreviewProductService } from "./services/preview-product/preview-product.service";
import { ColorService } from "./services/color/color.service";
import { CertificacionesService } from "./services/certificaciones/certificaciones.service";
import { CodigosProductoService } from "./services/codigos-prodicto/codigos-producto.service";
import { DocumentoService } from "./services/documento/documento.service";
import { CategoriaDocumentosService } from "./services/categoria-documentos/categoria-documentos.service";
import { ImageResizeService } from "./services/image-resize.service";

// Pipes
import { KeysPipe } from "./pipes/keys.pipe";
import { SecureDomPipe } from "./pipes/secure-dom.pipe";
import { NumberTwoDigitsPipe } from "./pipes/number-two-digits.pipe";
import { UnderlinedPipe } from "./pipes/underlined.pipe";
import { NoTildePipe } from "./pipes/no-tilde.pipe";

// Loaders
import { LoaderTextComponent } from "./components/loaders/loader-text/loader-text.component";
import { LoaderTitleComponent } from "./components/loaders/loader-title/loader-title.component";
import { LoaderImageComponent } from "./components/loaders/loader-image/loader-image.component";
import { LoaderDeskMenuComponent } from "./components/loaders/loader-desk-menu/loader-desk-menu.component";
import { ListadoCodigosComponent } from "./pages/admin/listado-codigos/listado-codigos.component";
import { CategoriasDocumentosComponent } from "./pages/admin/categorias-documentos/categorias-documentos.component";
import { CrearCategoriasDocumentosComponent } from "./pages/admin/crear-categorias-documentos/crear-categorias-documentos.component";
import { ListadoFichasComponent } from "./pages/admin/listado-fichas/listado-fichas.component";
import { CrearFichaComponent } from "./pages/admin/crear-ficha/crear-ficha.component";
import { ListadoMarcasComponent } from "./pages/admin/listado-marcas/listado-marcas.component";
import { CrearMarcaComponent } from "./pages/admin/crear-marca/crear-marca.component";
import { ListadoCertificacionesComponent } from "./pages/admin/listado-certificaciones/listado-certificaciones.component";
import { CrearCertificacionesComponent } from "./pages/admin/crear-certificaciones/crear-certificaciones.component";
import { CleanTagsPipe } from "./pipes/clean-tags.pipe";
import { LoaderAdminComponent } from "./components/loader-admin/loader-admin.component";
import { EspecialesComponent } from "./pages/admin/especiales/especiales.component";
import { DescuentosComponent } from "./pages/admin/descuentos/descuentos.component";
import { ConfiguracionComponent } from "./pages/admin/configuracion/configuracion.component";

import { AdminGuard } from "./guards/admin.guard";
import { CloseSessionComponent } from "./pages/admin/close-session/close-session.component";
import { FullScreenIframeComponent } from "./components/utils/fullscreen/full-screen-iframe.component";
import { IframeModalService } from "./services/general/fullscreen.service";

export function authHttpServiceFactory(http: Http, options: RequestOptions) {
  return new AuthHttp(new AuthConfig(), http, options);
}

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    NavlinksComponent,
    HomeComponent,
    FooterComponent,
    CategoriaComponent,
    ProductoComponent,
    KeysPipe,
    UnderlinedPipe,
    CotizacionComponent,
    FichaTecnicaComponent,
    BreadcrumbComponent,
    ResultadoBusquedaComponent,
    EspecialesSfComponent,
    GalleryComponent,
    SecureDomPipe,
    MediaViewerComponent,
    CategoriaEspecialComponent,
    LoaderTextComponent,
    LoaderTitleComponent,
    LoaderImageComponent,
    BasePublicComponent,
    BaseAdminComponent,
    LoginComponent,
    AdminNavbarComponent,
    AdminSiteComponent,
    AdminSiteMenuComponent,
    DestacadosHomeComponent,
    LoaderDeskMenuComponent,
    NumberTwoDigitsPipe,
    EditBannerComponent,
    EditPopupComponent,
    EditAdjuntoComponent,
    ConfirmComponent,
    EspecialesPortadaComponent,
    SeleccionSfComponent,
    BannerEncuentralosComponent,
    MarcasComponent,
    BandInformacionComponent,
    PopupComponent,
    AdjuntoComponent,
    CategoriasComponent,
    EditCategoriasComponent,
    CategoriasEspecialesComponent,
    NoTildePipe,
    CrearCategoriaEspecialComponent,
    EditBannerCategoriaComponent,
    PreviewCategoriaEspecialComponent,
    ListaProductosComponent,
    CrearProductoComponent,
    ColorSelectorComponent,
    CargarCodigosComponent,
    DescargarListadoCodigosComponent,
    EspecialesComponent,
    DescuentosComponent,
    ConfiguracionComponent,
    ListadoCodigosComponent,
    CategoriasDocumentosComponent,
    CrearCategoriasDocumentosComponent,
    ListadoFichasComponent,
    CrearFichaComponent,
    ListadoMarcasComponent,
    CrearMarcaComponent,
    ListadoCertificacionesComponent,
    CrearCertificacionesComponent,
    CleanTagsPipe,
    CrearCodigoComponent,
    SfGalleryComponent,
    OrdenarProductosComponent,
    HistorialCambiosProductosComponent,
    DescargarProductosComponent,
    PreviewProductoComponent,
    LoaderAdminComponent,
    CloseSessionComponent,
    FullScreenIframeComponent,
  ],
  exports: [FullScreenIframeComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    NgbModule.forRoot(),
    SlickModule.forRoot(),
    ToastModule.forRoot(),
    HttpModule,
    FormsModule,
    NgxGalleryModule,
    LaddaModule.forRoot({
      style: "zoom-out",
    }),
    DragulaModule,
    FileUploadModule,
    QuillModule,
    APP_ROUTING,
    ClickOutsideModule,
  ],
  providers: [
    // Http,
    { provide: LOCALE_ID, useValue: "es-CL" },
    TokenCommonService,
    GeneralService,
    BannerService,
    MarcaService,
    PopupService,
    BandaInformacionService,
    AdjuntoService,
    CategoriaService,
    ProductoService,
    CarritoService,
    UsuarioService,
    CotizacionService,
    LoginService,
    AuthService,
    ConfirmService,
    ArchivoService,
    PreviewFantasyCategoryService,
    PreviewProductService,
    ColorService,
    CertificacionesService,
    CodigosProductoService,
    DocumentoService,
    CategoriaDocumentosService,
    ImageResizeService,
    IframeModalService,
    { provide: ToastOptions, useClass: CustomOption },
    {
      provide: AuthHttp,
      useFactory: authHttpServiceFactory,
      deps: [Http, RequestOptions],
    },
    NoTildePipe,
    AdminGuard,
  ],
  entryComponents: [
    MediaViewerComponent,
    EditBannerComponent,
    EditPopupComponent,
    EditAdjuntoComponent,
    EditCategoriasComponent,
    EditBannerCategoriaComponent,
    CrearCategoriasDocumentosComponent,
    CrearFichaComponent,
    ConfirmComponent,
    CrearMarcaComponent,
    CrearCertificacionesComponent,
    CrearCodigoComponent,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// /app/src/app/app.module.ts